export default __webpack_public_path__ + "static/media/logo.328362f2.svg";